/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiAlbumCollectionsIdAlbumsMutationRequest, PostApiAlbumCollectionsIdAlbumsMutationResponse, PostApiAlbumCollectionsIdAlbumsPathParams, PostApiAlbumCollectionsIdAlbums400, PostApiAlbumCollectionsIdAlbums401, PostApiAlbumCollectionsIdAlbums403, PostApiAlbumCollectionsIdAlbums404, PostApiAlbumCollectionsIdAlbums500 } from "../../types/PostApiAlbumCollectionsIdAlbums.ts";
import { postApiAlbumCollectionsIdAlbumsMutationResponseSchema, postApiAlbumCollectionsIdAlbumsMutationRequestSchema } from "../../zod/AlbumCollectionSchemas/postApiAlbumCollectionsIdAlbumsSchema.ts";

function getPostApiAlbumCollectionsIdAlbumsUrl({ id }: { id: PostApiAlbumCollectionsIdAlbumsPathParams["Id"] }) {
  const res = { method: 'POST', url: `/api/album-collections/${id}/albums` as const }  
  return res
}

/**
 * @summary Добавление альбомов в выпуск
 * {@link /api/album-collections/:Id/albums}
 */
export async function postApiAlbumCollectionsIdAlbums({ id, data }: { id: PostApiAlbumCollectionsIdAlbumsPathParams["Id"]; data?: PostApiAlbumCollectionsIdAlbumsMutationRequest }, config: Partial<RequestConfig<PostApiAlbumCollectionsIdAlbumsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiAlbumCollectionsIdAlbumsMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiAlbumCollectionsIdAlbumsMutationResponse, ResponseErrorConfig<PostApiAlbumCollectionsIdAlbums400 | PostApiAlbumCollectionsIdAlbums401 | PostApiAlbumCollectionsIdAlbums403 | PostApiAlbumCollectionsIdAlbums404 | PostApiAlbumCollectionsIdAlbums500>, PostApiAlbumCollectionsIdAlbumsMutationRequest>({ method : "POST", url : getPostApiAlbumCollectionsIdAlbumsUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiAlbumCollectionsIdAlbumsMutationResponseSchema.parse(res.data)
}